
const init = (el, enable) => {

    const arrow = el;

    const data = el.data = el.data || {};
    if (data.scrollArrowControl) return data.scrollArrowControl;

    let showTimeout;
    let enabled = enable !== false;
    let _onClick = null;

    const showArrow = () => {
        if (!enabled) return;
        clearTimeout(showTimeout);
        arrow.classList.remove('hide');
    }

    const hideArrow = () => {
        if (!enabled) return;
        arrow.classList.add('hide');
        clearTimeout(showTimeout);
        showTimeout = setTimeout(showArrow, 1000);
    }

    const disableArrow = () => {
        if (!enabled) return;
        clearTimeout(showTimeout);
        arrow.classList.add('hide');
        enabled = false;
        removeListener();
    }

    const enableArrow = () => {
        if (enabled) return;
        enabled = true;
        hideArrow();
        addListener();
    }

    const _handleCLick = () => {
        if (_onClick)
            _onClick.call(window);
    }

    const addListener = () => {
        arrow.addEventListener('click', _handleCLick);
    }

    const removeListener = () => {
        arrow.removeEventListener('click', _handleCLick);
    }

    const ScrollArrowControl = {
        show() {
            showArrow();
        },
        hide() {
            hideArrow();
        },
        disable() {
            disableArrow();
        },
        enable() {
            enableArrow();
        },
        onClick(f) {
            _onClick = f;
        }

    };

    if (enabled)
        addListener();
    else
        hideArrow();

    data.scrollArrowControl = ScrollArrowControl;
    return ScrollArrowControl;
}

module.exports = init;


// WEBPACK FOOTER //
// ./js/viscom/viscomjs/ui/ScrollArrow.js